import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material';

export const AlignLeft = styled('section')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'left',
  alignItems: 'left',
  textAlign: 'left',
  gap: '1.5rem',
}));

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  background: theme.palette.primary.main,
  borderRadius: '.5rem',
  padding: '1.5rem',
  maxWidth: '35rem',

  [theme.breakpoints.up('sm')]: {
    padding: '2rem',
    width: '35rem',
  },
}));

export const changeValuePaperPropsStyle = {
  style: {
    backgroundColor: 'transparent',
    maxWidth: '35rem',
  },
};

export const StyledCloseIcon = styled(CloseIcon)(() => ({
  marginBottom: '1rem',
  alignSelf: 'flex-end',
  cursor: 'pointer',
}));

export const AlignButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  paddingTop: '1rem',
  justifyContent: 'right',
  gap: '1.5rem',

  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
}));
